<template>
	<div class="compCreateSeal">
		<div style="text-align: center;">
			<canvas id='canvas' width='250' height='250'></canvas>
		</div>
		<div id='hidMap'></div>
		<div style="text-align: center;padding:30px 0;">
			<el-button type="primary" @click="download" style="width: 200px;">生成印章</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				dw:"公司公司公司",
				dwText:'专用章',
				dwNum:'12345',
			}
		},
		computed:{
			// curShopId(){
			// 	return this.$store.state.shopId;
			// },
		},
		props:{
			msg:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			console.log(this.msg)
			this.dw = this.msg.companyName;
			this.dwText = this.msg.companyType;
			this.dwNum = this.msg.companyNumber;
			this.$nextTick(()=>{
				this.preview();
			})
		},
		methods: {
			download(){
				var canvas = document.getElementById('canvas');
				var blob = ''
				//判断是否是IE
				// var fileName = 'signature.png';
				if (window.navigator.msSaveBlob) {
					//支持IE10，IE11 ,Edage
					blob = canvas.msToBlob();
					// window.navigator.msSaveBlob(blob, fileName);
				} else {
					//下载图片,Goggle浏览器，火狐浏览器
					// var dataImg = new Image()
					// dataImg.src = canvas.toDataURL('image/jpeg',0.8)
					blob = canvas.toDataURL('image/png');
					// document.getElementById('hidMap').appendChild(dataImg)
				}
				let p = {
					"fileBase64": blob,
					"fileName": "xxx.png"
				}
				this.$upload.upload_img_base64(p).then(data => {
					if (data.timestamp) {
						let params = {
							"shopId": '',
							// "shopId": this.curShopId,
							"sealName": this.msg.signatureName,
							"sealType": this.msg.signatureType,  // 1公章；2合同章；3法人章；4财务章；5发票章；6其他用章
							"sealUrl": data.url,
						}
						console.log(params)
						let loading=this.$loading();
						this.$http.post(process.env.VUE_APP_business+'/api/Contract/Seal/Insert', params).then(res => {
							loading.close()
							if (res.code == 0) {
								this.$emit("submit",{type:'success'})
							}
						})
					}
				})
			},
			base64ToBlob(base64) {
				var arr = base64.split(',');
				var mime = arr[0].match(/:(.*?);/)[1] || 'image/png';
				// 去掉url的头，并转化为byte
				var bytes = window.atob(arr[1]);
				// 处理异常,将ascii码小于0的转换为大于0
				var ab = new ArrayBuffer(bytes.length);
				// 生成视图（直接针对内存）：8位无符号整数，长度1个字节
				var ia = new Uint8Array(ab);
				for (var i = 0; i < bytes.length; i++) {
					ia[i] = bytes.charCodeAt(i);
				}
				return new Blob([ab], {
					type: mime
				});
			},
			preview(){
				var canvas = document.getElementById('canvas');
				var context = canvas.getContext('2d');

				// 绘制圆形边框
				var width2 = canvas.width / 2;
				var height2 = canvas.height / 2;
				context.lineWidth = 7;
				context.strokeStyle = "#f00";
				context.beginPath();
				context.arc(width2, height2, 110, 0, Math.PI * 2);
				context.stroke();
				
				// 绘制中心
				this.drawCenter(context, width2, height2, 10, "#f00", 0);
				
				// 绘制名称
				context.font = '18px Helvetica';
				context.textBaseline = 'middle';//设置文本的垂直对齐方式
				context.textAlign = 'center'; //设置文本的水平对对齐方式
				context.lineWidth = 1;
				context.fillStyle = '#f00';
				context.fillText(this.dwText, width2, height2 + 65);
				
				// 绘制企业编号
				this.drawNumber(context,width2,height2,this.dwNum)
				
				// 绘制公司
				this.drawCompany(context,width2,height2,this.dw)
				
				
				
			},
			drawNumber(context,width2,height2,num){
				context.translate(width2,height2)
				context.font = '12px Helvetica'
				let count = num.length;// 字数
				let totalAngle = 0;
				let singleAngle = 0;
				let cha2 = Math.PI/2;
				if (count<=3) totalAngle = 1*Math.PI/6;
				else if (count<=6) totalAngle = 2*Math.PI/6;
				else if (count<=9) totalAngle = 2*Math.PI/6;
				else if (count<=12) totalAngle = 3*Math.PI/6;
				if(count>1){
					singleAngle = totalAngle/(count-1);
					cha2 = Math.PI/2-(totalAngle/2)
				}
				let chars = num.split("");
				for(let i=0;i<count;i++){
					let c = chars[i];
					if(i===0){
						context.rotate(-cha2)
					}else{
						context.rotate(-(singleAngle))
					}
					context.save();
					context.translate(-100,0)
					context.rotate(Math.PI/2)
					context.fillText(c,0,0)
					context.restore();
				}
				context.rotate(cha2+(singleAngle*(count-1)))
				context.save();
			},
			drawCompany(context,width2,height2,company){
				context.restore();
				context.font = '26px Helvetica'
				var count = company.length;// 字数
				let totalAngle = 0;
				let singleAngle = 0;
				let cha2 = Math.PI/2;
				if (count<=3) totalAngle = 2*Math.PI/6;
				else if (count<=6) totalAngle = 6*Math.PI/6;
				else if (count<=9) totalAngle = 6*Math.PI/6;
				else if (count<=12) totalAngle = 8*Math.PI/6;
				if(count>1){
					singleAngle = totalAngle/(count-1);
					cha2 = Math.PI/2-(totalAngle/2)
				}
				var chars = company.split("");
				for(let i=0;i<count;i++){
					let c = chars[i];
					if(i===0){
						context.rotate(cha2)
					}else{
						context.rotate((singleAngle))
					}
					context.save();
					context.translate(-89,0)
					context.rotate(-Math.PI/2)
					context.fillText(c,0,0)
					context.restore();
				}
				context.rotate(-cha2-(singleAngle*(count-1)))
				context.save();
			},
			drawCenter(context, sx, sy, radius, color, rotato) {
				context.save();
				context.fillStyle = color;
				context.translate(sx, sy);//移动坐标原点  
				context.rotate(Math.PI + rotato);//旋转  
				context.beginPath();//创建路径  
				var dig = Math.PI / 5 * 4;
				for (var i = 0; i < 5; i++) {//画五角星的五条边
					let x = Math.sin(i * dig);
					let y = Math.cos(i * dig);
					context.lineTo(x * radius, y * radius);
				}
				context.closePath();
				context.stroke();
				context.fill();
				context.restore();
			},
		}
	}
</script>

<style>
</style>
